export async function parseApiResponse(response) {
  const contentType = (response.headers.get('content-type') || '').toLowerCase();
  const bodyText = await response.text();

  let parsed = null;
  if (bodyText) {
    try {
      parsed = JSON.parse(bodyText);
    } catch (_err) {
      parsed = null;
    }
  }

  if (!response.ok) {
    const msg = parsed?.msg || bodyText || `Request failed (${response.status})`;
    throw new Error(msg);
  }

  if (parsed) {
    return parsed;
  }

  if (contentType.includes('application/json')) {
    throw new Error('Server returned invalid JSON payload.');
  }

  throw new Error('Server did not return JSON (is the API URL correct?)');
}
